import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=63e64f7d&"
import script from "./StaticPage.vue?vue&type=script&lang=ts&"
export * from "./StaticPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports